function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 2s-9.49 2.502-7 3c5 1 17.48 2.787 14.286 4.946-3.846 2.6-17.261 2.192-14.562 5.97C27.724 22.916 44 22 45 27c.837 4.186-4.357 4.535-8 10-4 6 18 14 18 14"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 52s2-10 8-15 9.105-3.587 12-8c2.895-4.413-8.695-11.076-7.848-14.038s2.953-3.762 12.414-5.654c3.637-.727-17.687-4.493-8.828-5.732L30 2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.41 37.409s1.165 2 2.204 2c1.04 0 1.165-2 2.204-2s1.165 2 2.205 2 1.165-2 2.204-2 1.165 2 2.204 2c1.04 0 1.165-2 2.204-2 1.04 0 1.165 2 2.204 2s1.166-2 2.205-2 1.166 2.054 2.204 2c.937-.048 1.753-2 1.753-2M9.41 41.409s1.165 2 2.204 2c1.039 0 1.165-2 2.204-2s1.165 2 2.204 2 1.165-2 2.204-2 1.165 2 2.205 2c1.039 0 1.165-2 2.204-2 1.039 0 1.165 2 2.204 2s1.165-2 2.204-2 1.167 2.054 2.204 2c.938-.048 1.753-2 1.753-2M13.41 45.409s1.165 2 2.204 2c1.04 0 1.165-2 2.204-2s1.165 2 2.205 2 1.165-2 2.204-2 1.165 2 2.204 2c1.04 0 1.165-2 2.204-2 1.04 0 1.165 2 2.204 2s1.166-2 2.205-2 1.166 2.054 2.204 2c.937-.048 1.753-2 1.753-2"
}));

var SvgRiver = function SvgRiver(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRiver, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/River.19665761.svg";
export { ForwardRef as ReactComponent };